import React from 'react';
import Chart from "react-google-charts";
import { useEffect, useState } from 'react';

import Loader from '../Utils/Loader.js';
import imgNoResultsDark from '../../img/dark-theme/empty-state.svg'
import ListGraphicEconomicsFilters from './ListEconomicsGraphicFilters.js'

const endpointHelias = "https://9m4y8iz04h.execute-api.eu-west-3.amazonaws.com/prod"
const postListBillingDates = endpointHelias+'/Helias/V0/General/postListBillingDates'

var initialConfigCommonJS = require("../../js/initialConfigCommon.js")
var dashbardCommonJS = require("../../js/dashboardCommon.js")
var analyticsCommonJS = require("../../js/analyticsCommon.js")
var generalCommonJS = require("../../js/generalCommon.js")

var etiquetas = [];
var filas = [];
var chartObj = ""
var googleObj = ""
var estadoVisibilidadLineasGráfica = []
var columns = []
var datos = [["Cargando", "Cargando"],["Cargando", 0],["Cargando", 0]]

// Para poder revertir al color original al mostrar / ocultar líneas
var backupColoresGrafica = {    
    0: { color: '#3498db' }, 
    1: { color: '#5EC264' },
    2: { color: '#F5B041' }, 
    3: { color: '#D65DB1' }, 
    4: { color: '#FF6F91' }, 
    5: { color: '#FF9671' }, 
    6: { color: '#845EC2' }, 
    7: { color: '#008F7A' }, 
    8: { color: '#FF8066' }, 
    9: { color: '#008E9B' }, 
    10: { color: '#EE82EE' }, 
    11: { color: '#FF4500' }, 
    12: { color: '#6495ED' }, 
    13: { color: '#483D8B' }, 
    14: { color: '#191970' }, 
    15: { color: '#FFF8DC' }, 
    16: { color: '#00FFFF' }, 
    17: { color: '#9932CC' }, 
    18: { color: '#BDB76B' }, 
    19: { color: '#000080' }, 
    20: { color: '#FFFACD' }, 
    21: { color: '#FAF0E6' }, 
    22: { color: '#D2691E' }, 
    23: { color: '#CD5C5C' }, 
    24: { color: '#2E8B57' }, 
    25: { color: '#778899' }, 
    26: { color: '#3CB371' }, 
    27: { color: '#FFDEAD' }, 
    28: { color: '#66CDAA' }, 
    29: { color: '#FFFAF0' }, 
    30: { color: '#8B0000' }, 
    31: { color: '#4682B4' }, 
    32: { color: '#F5FFFA' }, 
    33: { color: '#F0FFF0' }, 
    34: { color: '#7CFC00' }, 
    35: { color: '#FF00FF' }, 
    36: { color: '#FF8C00' }, 
    37: { color: '#87CEEB' }, 
    38: { color: '#F0F8FF' }, 
    39: { color: '#DA70D6' }, 
    40: { color: '#DCDCDC' }, 
    41: { color: '#BC8F8F' }, 
    42: { color: '#BA55D3' }, 
    43: { color: '#FFE4E1' }, 
    44: { color: '#FFFFF0' }, 
    45: { color: '#8B4513' }, 
    46: { color: '#F8F8FF' }, 
    47: { color: '#F5F5F5' }, 
    48: { color: '#ADFF2F' }, 
    49: { color: '#32CD32' }, 
    50: { color: '#00FFFF' }, 
    51: { color: '#C71585' }, 
    52: { color: '#D8BFD8' }, 
    53: { color: '#EEE8AA' }, 
    54: { color: '#FDF5E6' }, 
    55: { color: '#DDA0DD' }, 
    56: { color: '#FF6347' }, 
    57: { color: '#4B0082' }, 
    58: { color: '#7FFF00' }, 
    59: { color: '#A9A9A9' }, 
    60: { color: '#FFE4B5' }, 
    61: { color: '#008000' }, 
    62: { color: '#6A5ACD' }, 
    63: { color: '#FA8072' }, 
    64: { color: '#00FA9A' }, 
    65: { color: '#008B8B' }, 
    66: { color: '#8B008B' }, 
    67: { color: '#CD853F' }, 
    68: { color: '#DC143C' }, 
    69: { color: '#FF0000' }, 
    70: { color: '#F0E68C' }, 
    71: { color: '#48D1CC' }, 
    72: { color: '#40E0D0' }, 
    73: { color: '#90EE90' }, 
    74: { color: '#FFF5EE' }, 
    75: { color: '#FF69B4' }, 
    76: { color: '#F0FFFF' }, 
    77: { color: '#7B68EE' }, 
    78: { color: '#C0C0C0' }, 
    79: { color: '#000000' }, 
    80: { color: '#ADD8E6' }, 
    81: { color: '#228B22' }, 
    82: { color: '#D3D3D3' }, 
    83: { color: '#E9967A' }, 
    84: { color: '#F4A460' }, 
    85: { color: '#696969' }, 
    86: { color: '#F08080' }, 
    87: { color: '#FFFFFF' }, 
    88: { color: '#00CED1' }, 
    89: { color: '#00FF7F' }, 
    90: { color: '#808080' }, 
    91: { color: '#008080' }, 
    92: { color: '#A0522D' }, 
    93: { color: '#FFF0F5' }, 
    94: { color: '#87CEFA' }, 
    95: { color: '#9400D3' }, 
    96: { color: '#FFFF00' }, 
    97: { color: '#4169E1' }, 
    98: { color: '#5F9EA0' }, 
    99: { color: '#B8860B' }               
} 

const GoogleChartGraphics = (params) => {

    const [objEtiquetas, setObjEtiquetas] = useState([])        

    var options = {                       
        region: '002',                     
        backgroundColor: { fill:'transparent',fillOpacity: 0 },
        datalessRegionColor: '#F5F5F5',
        defaultColor: '#778ba5',
        chartArea:{left:35,top:10, bottom:45, right:6, width:"100%",height:"100%"},
        curveType: 'function',
        lineWidth: 2,
        pointSize: 8,
        pointsVisible:false, 
        legend: { 
          position: 'none'
        },
        hAxis: {
            textStyle: {fontName: 'hAxis'}
        },
        vAxis: {
            textStyle:{fontName: 'vAxis'},
            baselineColor: 'none',
            minorGridlines: {color: 'transparent'},
            viewWindowMode:"explicit",   
            viewWindow: { min: 0.00000001}
        },  
        xAxis: {
            textPosition: 'none',
            type: 'datetime',
            baselineColor:"transparent"
          },                  
        tooltip:{
            isHtml: true
        },                        
        animation:{
            startup: false,
            duration: 500,
            easing: 'inAndOut',
        },
        series: { ...backupColoresGrafica } 
        
    }

    useEffect(() => {                          

      obtenerDatosFacturas()                        
      console.log("Gráfica cargada / actualizada")          

    }, [params.objQueryGrafica]);    

    const chartEvents = [
    {
        eventName: "ready",
        callback: ({ chartWrapper, google }) => {
            chartObj = chartWrapper.getChart()
            googleObj = google            
        }
    }
    ];

    function inicializarElementosVisualesGráfica(){
        estadoVisibilidadLineasGráfica = []   
        options.series = { ...backupColoresGrafica } 
        columns = []

        for(var x=0; x < etiquetas.length; x++){
            if(document.getElementById("Etiqueta"+x) !== null){
                document.getElementById("Etiqueta"+x).style = 'color: '+backupColoresGrafica[x-1].color
                document.getElementById("Etiqueta"+x).className = document.getElementById("Etiqueta"+x).className.replace("secondary", "tertiary")                 
            }
        }

        setObjEtiquetas(etiquetas)      
    }
    
    function showHideSeries(chart,google,item) {

        if(estadoVisibilidadLineasGráfica.length === 0){
            for(var x = 0; x < etiquetas.length; x++){
                estadoVisibilidadLineasGráfica.push("on")
            }
        }

        var data = new google.visualization.DataTable();    

        for (var i = 0; i < etiquetas.length; i++) {
            if(i === 0){			
                data.addColumn('string', etiquetas[i]);                
            }
            else{
                data.addColumn('number', etiquetas[i]);
            }            
        }
    
        data.addRows(filas);
      
        var sel = item   
        
        if(columns.length === 0){
            columns = etiquetas.map((x) => x);
        }        
                        
        if (sel.length > 0) {
            
            // if row is undefined, we clicked on the legend
            if (sel[0].row === null) {      
                var col = sel[0].column;                
                var estadoFiltroTrasAccion = 0

                if(estadoVisibilidadLineasGráfica[col] === "on"){
                    estadoFiltroTrasAccion = 1
                }

                var numeroFiltrosSeleccionados = estadoVisibilidadLineasGráfica.filter(x => x==="on").length - estadoFiltroTrasAccion
        
                if( numeroFiltrosSeleccionados < 2){
                    initialConfigCommonJS.mostrarMensajeInformativo("¿En serio quieres una gráfica vacía? Debe haber al menos un valor seleccionado.","info")                    
                }
                else{
                
                    if (estadoVisibilidadLineasGráfica[col] === "on") {                                 
                        // hide the data series
                        columns[col] = {
                            label: columns[col],
                            type: data.getColumnType(col),                        
                            calc: function () {
                                return null;
                            }
                        };    
                        // grey out the legend entry                        
                        options.series[col-1] = {color: '#CCCCCC'} 
                        estadoVisibilidadLineasGráfica[col] = "off"
                        document.getElementById("Etiqueta"+col).style = ' color: #CCCCCC;background-color:rgba(0, 0, 0, 0.0);'
                        document.getElementById("Etiqueta"+col).className = document.getElementById("Etiqueta"+col).className.replace("tertiary", "secondary")         
                    }
                    else {                        
                        // show the data series                    
                        options.series[col-1] = backupColoresGrafica[col-1];                
                        columns[col] =  col
                        estadoVisibilidadLineasGráfica[col] = "on"             
                        document.getElementById("Etiqueta"+col).style = 'color: '+backupColoresGrafica[col-1].color
                        document.getElementById("Etiqueta"+col).className = document.getElementById("Etiqueta"+col).className.replace("secondary", "tertiary")                    
                    }

                    var view = new google.visualization.DataView(data);                        
                    view.setColumns(columns);            
                    chart.draw(view, options);                    

                }                
            }
        }            
    }

    function obtenerDatosFacturas(){

        var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
        var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")        
            
        //Petición de datos 
        var jsonPeticion = {
          "accountID": localStorage.getItem("accountID"),
          "installationID": localStorage.getItem("installationId")
        }
      
        // Guardo la información  
        var xhttp = new XMLHttpRequest();  
          xhttp.open("POST", postListBillingDates, true);        
          xhttp.setRequestHeader('Content-Type', "application/json");
          xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
          var data = JSON.stringify(jsonPeticion);
          xhttp.onreadystatechange = function() {
          if (this.readyState === 4 && this.status === 200) {
            var jsonRespuesta = JSON.parse(this.responseText)
      
            if(jsonRespuesta.statusCode === "403"){                   
              initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
            }
            else{          
              //Si recibo datos ya configurados lo cargo  
      
              if(jsonRespuesta.body.length > 0){
                
                document.getElementById("componenteEnvioFactura").className = document.getElementById("componenteEnvioFactura").className.replaceAll(" hidden", "")
      
                var opt;
                var numeroMesAMostrar;
                var numeroAñoAMostrar;
      
                //Borro las opciones que haya
                while (document.getElementById("selectFechaFactura").options.length > 0) {
                  document.getElementById("selectFechaFactura").remove(0);
                }
      
                for(var x=0; x<jsonRespuesta.body.length; x++){                    
                  opt = document.createElement('option')
                  opt.value = jsonRespuesta.body[x].DATE          
                  numeroMesAMostrar = jsonRespuesta.body[x].DATE.split("-")[1] - 1                    
                  numeroAñoAMostrar = jsonRespuesta.body[x].DATE.split("-")[0]
      
                  if(numeroMesAMostrar < 1){ //Si estoy en enero muestro diciembre
                    numeroMesAMostrar = 12
                    numeroAñoAMostrar = numeroAñoAMostrar -1
                  }

      
                  opt.innerHTML = numeroAñoAMostrar + " - " + dashbardCommonJS.obtenerNombreMes(numeroMesAMostrar) 
                  document.getElementById("selectFechaFactura").appendChild(opt)
                }
      
                document.getElementById("selectFechaFactura").selectedIndex = jsonRespuesta.body.length-1
      
              }
              else{
                document.getElementById("componenteEnvioFactura").className = document.getElementById("componenteEnvioFactura").className.replaceAll(" hidden", "") + " hidden"
              }

              //Ahora añado a los resultados la información actual
                      
              var tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
              var fechaActual = (new Date(Date.now() - tzoffset)).toISOString().substring(0,10)

              var datosEconomicsActual = JSON.parse(localStorage.getItem("lastDashboardData")).SelfConsumptionAndSavingsData
    
              var currentSolarWalletBalance = ""
              try{ currentSolarWalletBalance = datosEconomicsActual.CurrentSolarWalletBalance.Value } 
              catch(error){ currentSolarWalletBalance = "0.00" }
    
              var currentMonthsavingsBalance = ""
              try{ currentMonthsavingsBalance = datosEconomicsActual.CurrentMonthsavingsBalance.Value }
              catch(error){ currentMonthsavingsBalance = "0.00" }
    
              var currentMonthselfConsumptionBalance = ""
              try{ currentMonthselfConsumptionBalance = datosEconomicsActual.CurrentMonthselfConsumptionBalance.Value }
              catch(error){ currentMonthselfConsumptionBalance = "0.00" }
    
              var jsonEconomicsActual = {
                "DATE": fechaActual,
                "DATA": {
                  "CurrentMonthsavingsBalance": parseFloat(currentMonthsavingsBalance).toFixed(2),                
                  "CurrentMonthselfConsumptionBalance": parseFloat(currentMonthselfConsumptionBalance).toFixed(2),
                  "CurrentSolarWalletBalance": parseFloat(currentSolarWalletBalance).toFixed(2)
                }
              }
    
              jsonRespuesta.body.push(jsonEconomicsActual)

              datos = procesarDatosGrafica(jsonRespuesta.body)
              inicializarElementosVisualesGráfica()
           
              console.log("Fechas de facturas cargadas correctamente.")

              if(document.getElementById("loadergraficaHistoricalEconomics") !== null){
                document.getElementById("loadergraficaHistoricalEconomics").className = "loader contextual hidden"  
              }          
            }
      
          }
      
          if (this.readyState === 4 && this.status !== 200) {   
              initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)          
          }
        }
        xhttp.send(data); 
      
    }
      
    function procesarDatosGrafica(objResultadosQuery){
       
        var objResultados = objResultadosQuery
        var datosRespuesta = []        
      
        if ( (objResultados.length > 0) && (typeof objResultados !== 'undefined') ){    
      
            if(Object.keys(objResultados[0]).length > 1){
      
                var jsonObjDashboard = JSON.parse(localStorage.getItem("lastDashboardData"))
      
                var instalacionConPaneles = false
                var instalacionConMonedero = false
                var instalacionConectadaAlaRed = false
                
                if(Object.keys(jsonObjDashboard.FVData).length > 0){
                  instalacionConPaneles = true
                  if(jsonObjDashboard.FVData.SolarWallet === "true"){
                    instalacionConMonedero = true
                  }                  
                }

                if(jsonObjDashboard.InstallationData.GeneralInfo.EnergyGridConnected === "true"){
                  instalacionConectadaAlaRed = true                  
                }
      
                //Obtengo las keys de los ejes
                var keysResultados = Object.keys(objResultados[0].DATA)      
                var keysOrdenadas = []
                
                //Seteo las etiquetas
                keysOrdenadas.push(initialConfigCommonJS.obtenerLiteralAtributo("TituloGraficaEconomics"))          
      
                for(var n=0; n < keysResultados.length; n++){                       
                  
                  if (keysResultados[n] === "CurrentMonthselfConsumptionBalance"){
                    if(instalacionConPaneles){
                      keysOrdenadas.push(initialConfigCommonJS.obtenerLiteralAtributo(keysResultados[n]+"GraficaEconomics"))                   
                    }
                  }
                  else if (keysResultados[n] === "CurrentSolarWalletBalance"){
                    if(instalacionConMonedero){
                      keysOrdenadas.push(initialConfigCommonJS.obtenerLiteralAtributo(keysResultados[n]+"GraficaEconomics"))                   
                    }
                  }
                  else{
                    if(instalacionConectadaAlaRed){
                      keysOrdenadas.push(initialConfigCommonJS.obtenerLiteralAtributo(keysResultados[n]+"GraficaEconomics"))                   
                    }
                  }

                }
      
                datosRespuesta.push(keysOrdenadas)
                
                etiquetas = keysOrdenadas
                
                //Ahora agrego los datos
                var valorTemp = []
                var keyTemp = ""
                var valorAtributo = 0
                var unidadAtributo = ""                
                var numeroMesAMostrar = 0
                var numeroAñoAMostrar = 0

                var fechaFacturacion = JSON.parse(localStorage.getItem("lastDashboardData")).SelfConsumptionAndSavingsData.BillingStartDate
                var diaInicioFacturacionActual = parseInt(fechaFacturacion.split("/")[0])
                var mesInicioFacturacionActual = parseInt(fechaFacturacion.split("/")[1])

                var diaActualPeriodo = ""
                var mesActualPeriodo = ""

                // Ahora filtro únicamente los últimos 12 meses

                if(objResultados.length > 12){

                  var numeroRegistrosSobrantes = objResultados.length - 12
                  
                  for(var e=0; e<numeroRegistrosSobrantes; e++){
                    objResultados.shift()
                  }
                }

                for(var x=0; x < objResultados.length; x++){ //Todos los resultados          
                
                    valorTemp = []       
                    keyTemp = ""

                    numeroAñoAMostrar = parseInt(objResultados[x].DATE.split("-")[0])

                    if(x === (objResultados.length-1)){

                      diaActualPeriodo = parseInt(objResultados[x].DATE.split("-")[2])
                      mesActualPeriodo = parseInt(objResultados[x].DATE.split("-")[1])                      

                      if( (diaActualPeriodo < diaInicioFacturacionActual) && (mesActualPeriodo >= mesInicioFacturacionActual) ){
                        numeroMesAMostrar = parseInt(objResultados[x].DATE.split("-")[1])-1
                      }
                      else{
                        numeroMesAMostrar = objResultados[x].DATE.split("-")[1]
                      }

                    }
                    else{                      
                      numeroMesAMostrar = objResultados[x].DATE.split("-")[1] - 1                    
                      if(numeroMesAMostrar === 0){
                        numeroMesAMostrar = 12
                        numeroAñoAMostrar = numeroAñoAMostrar - 1
                      }
                    }
                    
      
                    if(numeroMesAMostrar < 1){ //Si estoy en enero muestro diciembre
                      numeroMesAMostrar = 12
                    }
      
                    if( generalCommonJS.obtenerTipoPlataforma().includes("Web")){      
                      valorTemp.push( dashbardCommonJS.obtenerNombreMes(numeroMesAMostrar).substring(0,3) + " '" + numeroAñoAMostrar.toString().substring(2,4))                                            
                    }
                    else{
                      valorTemp.push( parseInt(numeroMesAMostrar)+ "\n'" + numeroAñoAMostrar.toString().substring(2,4))
                    }                    
                
                    for(var y=0; y < keysResultados.length; y++){ //Keys de cada resultado                              
        
                      if (keysResultados[y] === "CurrentMonthselfConsumptionBalance"){
                        if(instalacionConPaneles){                    
                          valorAtributo = parseFloat(objResultados[x].DATA[keysResultados[y]])
                          unidadAtributo = analyticsCommonJS.obtenerUnidadAtributo(keysResultados[y])
      
                          valorAtributo = Math.abs(valorAtributo)
                            
                          keyTemp = {v: valorAtributo, f: new Intl.NumberFormat('en-DE').format(valorAtributo.toFixed(2)) + " " + unidadAtributo}
                          valorTemp.push(keyTemp)
                        }
                      }
                      else if (keysResultados[y] === "CurrentSolarWalletBalance"){
                        if(instalacionConMonedero){
                          valorAtributo = parseFloat(objResultados[x].DATA[keysResultados[y]])
                          unidadAtributo = analyticsCommonJS.obtenerUnidadAtributo(keysResultados[y])
      
                          valorAtributo = Math.abs(valorAtributo)
                            
                          keyTemp = {v: valorAtributo, f: new Intl.NumberFormat('en-DE').format(valorAtributo.toFixed(2)) + " " + unidadAtributo}
                          valorTemp.push(keyTemp)
                        }
                      }
                      else{
                        if(instalacionConectadaAlaRed){
                          valorAtributo = parseFloat(objResultados[x].DATA[keysResultados[y]])
                          unidadAtributo = analyticsCommonJS.obtenerUnidadAtributo(keysResultados[y])
        
                          valorAtributo = Math.abs(valorAtributo)
                            
                          keyTemp = {v: valorAtributo, f: new Intl.NumberFormat('en-DE').format(valorAtributo.toFixed(2)) + " " + unidadAtributo}
                          valorTemp.push(keyTemp)
                        }
                      }          
                      
                    }
                  
                    datosRespuesta.push(valorTemp)     
                    
                }
            }
        }        
        else{ 
      
          //Inicializo la tabla vacia para evitar el mensaje de msegs "Table has no columns" durante la carga
          datosRespuesta = [[initialConfigCommonJS.obtenerLiteralAtributo("TituloGraficaEconomics"),""],["", 0]]         
            
        }
      
        var copiaDatos = datosRespuesta.map((x) => x);
        copiaDatos.shift()
        filas = copiaDatos

        return datosRespuesta
    }
      
    return (
        <>

            <div id={params.graphicId} >
            
                <Chart
                    width={'100%'}
                    height={'100%'}
                    chartType="ColumnChart"
                    chartEvents={chartEvents}
                    chartLanguage='es'
                    data={datos} 
                    options={options}
                />

                <ListGraphicEconomicsFilters 
                    objEtiquetas={objEtiquetas}
                    backupColoresGrafica={backupColoresGrafica}
                    showHideSeries={showHideSeries}
                    chartObj={chartObj}
                    googleObj={googleObj}
                />

            </div>


            <div id={"mensajeNoHayDatosGrafica"+params.graphicId} className="message medium empty hidden">
                <picture>
                    <source srcSet={imgNoResultsDark} media="(prefers-color-scheme: dark)"/>
                    <img src={imgNoResultsDark} alt=" "/>
                </picture>
                <h1 className="title">No hay datos para mostrar en este periodo.</h1>                
                
            </div>

        <Loader Id={"loader"+params.graphicId} Mensaje="" initialStatus="contextual"/>

        </>
    );
}

export default GoogleChartGraphics